/*
 *
 */
import * as React from 'react';
import Page from '../components/page';
import Form from '../components/form';
import { StaticImage } from 'gatsby-plugin-image';

/*
 *
 */
const PageContent = () => {
	return (
		<Page
			title="Demande de rendez-vous"
			intro={'Toute personne peut un jour ou l’autre sentir qu’elle a besoin d’être aidée, de parler, de déposer sa souffrance ou tout simplement d’être entendue. Poussez la porte et créez un changement positif dans votre vie.'}
			content={null}
		>

			<div style={{ marginBottom: '4rem' }}>
				<StaticImage
					key="img"
					className="limitheight"
					backgroundColor="rgba(255,255,255,.25)"
					src="../images/RDV-Isabelle-Kopp.jpeg"
					alt="Rendez-vous - Isabelle Kopp"
					width={1920}
					sizes="(max-width: 768px) 50vw, 960px"
				/>
			</div>

			<div>
				<Form />
			</div>
			<title>Rendez-vous — Isabelle Kopp</title>
		</Page>
	);
};

export default PageContent;
